var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27256 14.6787L6.27275 14.6785L10.6265 10.3176L14.9802 5.95674L14.9805 5.95648C15.7866 5.14736 17.2143 5.14799 18.0208 5.95748L18.0211 5.95787C18.8595 6.79679 18.8597 8.16409 18.021 9.00418L9.31374 17.7258L9.31355 17.726C8.72696 18.3125 7.91393 18.65 7.08611 18.65H5.50003C5.41785 18.65 5.35 18.5829 5.35 18.4992V16.9105C5.35 16.0654 5.67737 15.274 6.27256 14.6787Z",
    stroke: "currentColor",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6724 7.35742L16.5391 10.2246",
    stroke: "#5260FE",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.cc50b1cd98de7d160e0bc2454fecfedc.svg";
export { ForwardRef as ReactComponent };